import { Component } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { SettingsRequestViewModalComponent } from '../request-view-modal/request-view-modal.component';

@Component({
  selector: 'setting-request-renderer',
  template: '<div class="cell-modal-link"> <a class="request-renderer" (click)="openModal()">{{ value }}</a></div>'
})

export class SettingRequestViewRendererComponent implements ICellRendererAngularComp {
  private params: any;
  public value!: string;

  constructor(
    private modalService: NgbModal
  ) { }

  openModal() {
    const modal = this.modalService.open(SettingsRequestViewModalComponent, { size: 'lg', windowClass: "lytxModal", centered: true });
    modal.componentInstance.requestId = this.value;
  }

  agInit(params: any) {
    this.params = params;
    this.value = this.params.value;
  }

  refresh(params: any): boolean {
    this.params = params;
    this.value = this.params.value;
    return true;
  }
}
